import { mapperEventAgendaSection } from '../event-agenda-section/mapper-event-agenda-section'
import { mapperEventLocation } from '../event-location/mapper-event-location'
import { mapperModuleMedia } from '#layers/core/data-layer/modules/module-media/mapper-module-media'
import type { MapperImageOptions } from '~/types'

/**
 * BlockEventLogistics

 */
export const mapperEventLogistics = (data: any, imageOptions: MapperImageOptions) => {
  if (!data) {
    return null
  }

  const mapSection = (item: any) => {
    const contentType = item?.contentType || ''

    switch (contentType) {
      case 'EventAgendaSection': {
        return { agenda: mapperEventAgendaSection(item) }
      }
      case 'EventLocation': {
        return { location: mapperEventLocation(item) }
      }
      default: {
        return {}
      }
    }
  }

  return {
    id: data.sys?.id || '',
    sys: data.sys || null,
    contentType: data.contentType,
    title: data.title || '',
    description: data.description || {},
    image: mapperModuleMedia(data.image, imageOptions) || null,
    map: data.map || null,
    ...mapSection(data.eventAgendaOrLocationSection)
  }
}
